import { createFileRoute } from '@tanstack/react-router'
import { COMPLIANCE_STAFF_ROLES } from '@workspace/utils'
import { CompliancePartnersPage } from '@/features/compliance-partners'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'

/**
 * Task 9 (phase-3a): mirrors `/compliance/findings`'s role list exactly — the
 * tighter compliance-staff set (no `health_carer` / `supported_employee`), so
 * a support worker is bounced to /403 up front instead of a page whose data
 * all 403s underneath it.
 * Role-list reconciliation: shared via `@workspace/utils` — see hub.tsx's
 * comment for why this stopped being six independent hand-typed copies.
 */
export const Route = createFileRoute('/_authenticated/_organization/compliance/partners')({
  beforeLoad: async () => {
    await requireRoles([...COMPLIANCE_STAFF_ROLES])
    await requireActiveSubscription()
  },
  component: CompliancePartnersPage,
})
